"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.reports.cost': 'Informes de Costos',
    'route.reports.shared': 'Conversaciones Compartidas',
};
